export const LINK_ACCESS_DENIED = '/403';
export const LINK_SIGN_IN = '/sign-in';
export const LINK_PASSWORD_FORGOT = '/password-forgot';
export const LINK_PASSWORD_RESET = '/password-reset';
export const LINK_PASSWORD_SETUP = '/password-setup';
export const LINK_START = '/start';
export const LINK_START_STEP = '/start/step';
export const LINK_START_VERIFICATION = '/start/verification';
export const LINK_START_FIRST = LINK_START_STEP + '/1';
export const LINK_START_LAST = LINK_START_STEP + '/6';
export const LINK_BLOCKED = '/blocked';
export const LINK_TFA_VERIFICATION = '/tfa-verification';
export const LINK_TFA_RESET = '/tfa-reset';

export const LINK_DASHBOARD = '/dashboard';
export const LINK_WITHDRAW = '/withdraw';
export const LINK_WITHDRAW_DETAILS = '/dashboard/withdraw';
export const LINK_PAYMENTS = '/payments';
export const LINK_PAYMENT_DETAILS = '/payments/details';
export const LINK_TRANSACTIONS = '/transactions';
export const LINK_ROLLING_RESERVE = '/rolling-reserve';
export const LINK_DEVELOPER_OPTIONS = '/developer-options';
export const LINK_CREATE_APP = '/developer-options/create';
export const LINK_EDIT_APP = '/developer-options/edit';
export const LINK_APP = '/developer-options/details';
export const LINK_CRYPTO_WALLETS = '/crypto-wallets/';
export const LINK_CREATE_CRYPTO_WALLET = '/crypto-wallets/create';
export const LINK_EDIT_CRYPTO_WALLET = '/crypto-wallets/edit';

export const LINK_MANAGEMENT = '/management';
export const LINK_WITHDRAWAL_ACCOUNTS = LINK_MANAGEMENT;
export const LINK_BANK_ACCOUNT_CREATE = `${LINK_WITHDRAWAL_ACCOUNTS}?id=create`;

export const LINK_SETTINGS = '/settings';
export const LINK_HELP = '/help';


// global admin prefix

export const LINK_ADMIN_ROOT = "/admin";

// admin menu routing

export const LINK_ADMIN_DASHBOARD = "/";

export const LINK_ADMIN_TRX = "/transactions";
export const LINK_ADMIN_CUSTOMERS = "/customers";
export const LINK_ADMIN_RETAILERS = "/retailers";
export const LINK_ADMIN_RULES = "/rules";
export const LINK_ADMIN_PARTNERS = "/partners";
export const LINK_ADMIN_STATEMENTS = "/statements";
export const LINK_ADMIN_ANALYTICS = "/analytics";
export const LINK_ADMIN_SETTINGS = "/settings";

// global admin

export const LINK_ADMIN_ADD = "/add";

// admin 2nd layer menu

export const LINK_ADMIN_DATA = "/data";
export const LINK_ADMIN_BALANCE_PROFILE = "/balance-profile";
export const LINK_ADMIN_PAYMENT_HISTORY = "/payment-history";
export const LINK_ADMIN_CONFIG = "/config";
